import 'dotenv/config';

const LAD_APISERVER_URL = process.env.REACT_APP_LAD_APISERVER_URL;

export { LAD_APISERVER_URL };
